<template
  ><div style="padding-top:-2px;margin-top:-2px;">
    <v-label
      ><b>{{ label }}</b></v-label
    >
    <s-select-generic
      autocomplete
      class="text"
      itemvalue="DriverName"
      :disabled="disabled"
      :value="value"
      id="DriverName" itemtext="DriverName"
      :return-object="returnObject"
      @input="input($event)"
      :config="config"
      :full="full"
      :text="text"
      :clearable="clearable"
      :noDefault="clearable"
    >
    </s-select-generic>
  </div>
</template>

<script>
import _sReceptionSurveillance from "../../services/Technicalassistance/ReceptionSurveillanceService";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },    
    full: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
   /*  value(value) {
      this.item = value;
      console.log("item",  this.item);
    }, */
  },
  methods: {
    input(val) {
      this.$emit("input", val);
      console.log("input", val);
    },
  },
  data: () => ({
    /* item: {}, */
   /*  val: "", */
    /* items: [], */
    config: {},
  }),

  created() {
    this.config = {
      url: _sReceptionSurveillance.GetDriver(),
      title: this.label,
      params: { search: "", requestID: this.$fun.getUserID() },
    };
  },
};
</script>
